import { StyledSpinnerWrapper, StyledSpin } from 'components/styledComponents/spin/Spin.styled';
import { useIsAdminModalOpen } from 'hooks';
import { useFullscreen } from 'contexts/FullscreenContext';
import { useAppSelector } from 'store/hooks';
import { selectUserConfigMenuCollapse } from 'app/userPreferences/selectors';
import { selectPageLoading } from 'app/settings/selectors';

const Loading = () => {
  const { fullscreen } = useFullscreen();
  const isModalOpen = useIsAdminModalOpen();

  const menuCollapse = useAppSelector(selectUserConfigMenuCollapse);
  const pageLoading = useAppSelector(selectPageLoading);

  return (
    <StyledSpinnerWrapper className={`spin ${pageLoading ? 'spin-loading' : ''}`}>
      <StyledSpin spinning={pageLoading} $collapsed={menuCollapse} $isFullSize={fullscreen || isModalOpen} />
    </StyledSpinnerWrapper>
  );
};

export default Loading;
